import { GOTIVA_ARTIST_DOC_ID } from 'app-constants';
import { PremiumPuzzlePrice } from 'types/components/PremiumPuzzlePrice';

//Premium puzzles. Get tier label.
export const getPuzzlePremiumTierLabel = (tier: number): string => {
  if (tier === 0) return 'Free';
  return `${tier} Tier`;
};

//Premium puzzles. Get all dropdown options.
export const getDropdownPuzzlePremiumOptions = (
  premiumPuzzlePrice: PremiumPuzzlePrice | null,
): { value: number; label: string }[] => {
  const data = [{ value: 0, label: getPuzzlePremiumTierLabel(0) }].concat(
    premiumPuzzlePrice?.tiers
      ? Object.keys(premiumPuzzlePrice.tiers).map((key) => ({
          value: parseInt(key),
          label: getPuzzlePremiumTierLabel(parseInt(key)),
        }))
      : [],
  );
  return data;
};

//Premium puzzles. Check if artist is Gotiva Artist since only their puzzle can be set as Premium.
export const checkIfIsGotivaArtist = (compareId: string): boolean =>
  compareId === GOTIVA_ARTIST_DOC_ID;
